// import 'swiper';
import Swiper, { Navigation, Autoplay, Thumbs, Mousewheel, Pagination } from 'swiper';
const breakpoint = window.matchMedia('(min-width:768px)');
let tileSwiper;

new Swiper('.filter-control_type_scroller', {
  slidesPerView: 1,
  spaceBetween: 0,
});

new Swiper('.slides_content_pos .swiper', {
  modules: [Navigation],
  spaceBetween: 0,
  navigation: {
    nextEl: '.slides_content_pos .swiper-nav__btn_dir_next',
    prevEl: '.slides_content_pos .swiper-nav__btn_dir_prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    576: {
      slidesPerView: 2,
    },
    320: {
      slidesPerView: 1,
    },
  }
});

new Swiper('.promo__slides', {
    modules: [Navigation, Autoplay],
    slidesPerView: 1,
    spaceBetween: 0,
    /*
    autoplay: {
        delay: 5000,
    },
    */
    navigation: {
      prevEl: '.promo__nav .swiper-nav__btn_prev',
      nextEl: '.promo__nav .swiper-nav__btn_next',
    },
});

new Swiper('.partners__slides', {
  modules: [Autoplay],
  slidesPerView: 5,
  spaceBetween: 0,
  loop: true,
  autoplay: {
      delay: 3000,
  }
});

new Swiper('.workers__slides', {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    prevEl: '.workers__nav .swiper-nav__btn_prev',
    nextEl: '.workers__nav .swiper-nav__btn_next',
  },
});

new Swiper('.own__slides', {
  modules: [Navigation, Autoplay],
  slidesPerView: 1,
  spaceBetween: 16,
  breakpoints: {
    320: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 5,
    },
    1440: {
      slidesPerView: 3,
    },
  },
  autoplay: {
      delay: 5000,
  },
  navigation: {
    prevEl: '.own__nav .swiper-nav__btn_prev',
    nextEl: '.own__nav .swiper-nav__btn_next',
  },
});

const tabPaneSlidesArr = [];
const tabPaneSlidesSel = '.tab-pane__slides';
const tabPanesArr = Array.from(document.querySelectorAll(tabPaneSlidesSel));

function setArrValues(value) {
  tabPaneSlidesArr.push(value);
  return tabPaneSlidesArr;
}

function setSwiper(sel) {
  const swiper = new Swiper(sel, {
    spaceBetween: 0,
    slidesPerView: 2,
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
    }
  });
  return swiper;
}

for(let i = 0; i < tabPanesArr.length; i++) {
  setArrValues(null);
}
const swiper = new Swiper(".company-manifest-swiper-smal", {
  spaceBetween: 10,
  slidesPerView: 'auto',

});
const swiper2 = new Swiper(".company-manifest-swiper-big", {
  modules: [Navigation, Thumbs],
  navigation: {
    nextEl: ".swiper-nav__btn_next",
    prevEl: ".swiper-nav__btn_prev",
  },
  thumbs: {
    swiper: swiper,
  },
});

new Swiper('.company-diploma__slider', {
  modules: [Navigation],
  slidesPerView: 'auto',
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-diploma-nav__btn_next',
    prevEl: '.swiper-diploma-nav__btn_prev',
  },
});

new Swiper('.compaund-info__sliders', {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 16,
  navigation: {
    nextEl: '.swiper-nav__btn_info_prev',
    prevEl: '.swiper-nav__btn_info_next',
  },
});


/* pos */
const posGalleryThumbs = new Swiper('.swiper-container_thumbs', {
	slidesPerView: 'auto',
	//init:false,
  });

  const posGalleryMain = new Swiper('.swiper-container_main', {
	modules: [Thumbs],
	//init:false,
	slidesPerView: 1,
	breakpoints: {
	  768: {
		slidesPerView: 1,
	  },
	  520: {
		spaceBetween: 35,
		slidesPerView: 1.3,
	  },
	  320: {
		spaceBetween: 35,
		slidesPerView: 1.1,
	  },
	},
	thumbs: {
		swiper: posGalleryThumbs
	}
  });
  window._posGalleryM = posGalleryMain;
  window._posGalleryT = posGalleryThumbs;

const breakpointChecker = () => {
  if ( breakpoint.matches === true ) {
    tabPaneSlidesArr.forEach(tabPaneSlidesArrEl => {
      if (tabPaneSlidesArrEl) {
        tabPaneSlidesArrEl.destroy( true, true );
        return;
      }
    });
  } else if ( breakpoint.matches === false ) {
    setArrValues(setSwiper(tabPaneSlidesSel));
  }
};

breakpoint.addListener(breakpointChecker);
breakpointChecker();

function setActiveSlide(arr, index, attr) {
  const yearListArr = [];
  const yearAttrListArr = arr.map(item => item.getAttribute(attr));
  const slideId = arr[index].getAttribute(attr);
  for(let i = 0; i < yearAttrListArr.length; i++) {
    if(yearAttrListArr[i] != yearAttrListArr[i+1]) {
      yearListArr.push(yearAttrListArr[i]);
    }
  }

  const slideHolder = {
    el: document.querySelector(slideId).parentNode,
    indexEl: yearListArr.indexOf(slideId)
  };
  const { el, indexEl } = slideHolder;
  el.style.transform = `translateY(-${100*indexEl}%)`;
}

const calendarControls = new Swiper('.calendar__carousel', {
  modules: [Mousewheel, Pagination],
  slidesPerView: 'auto',
  mousewheel: true,
  direction: 'vertical',
	breakpoints: {
	  768: {
      direction: 'vertical',
	  },
	  320: {
      direction: 'horizontal',
	  },
	},
  pagination: {
    el: '.calendar__scrollbar',
    type: 'progressbar',
    progressbarFillClass: 'calendar__scrollbar-fill'
  },
  on: {
    activeIndexChange: () => {
      setActiveSlide(calendarControls.slides, calendarControls.activeIndex, 'data-target');
    },
  }
});